import { type AvailableCoupon } from '@hooks-api/types/dataModel/coupon'
import { type ECommerceProduct } from '@hooks-api/types/dataModel/products'

/**
 * Parse availableCoupons to giveawayProductIds
 */
export const parseAvailableCouponCriterionGiveawayProductIds = (availableCoupons?: AvailableCoupon[]): ECommerceProduct['id'][] =>
  availableCoupons?.flatMap(coupon =>
    coupon.criterion_groups.flatMap(criterionGroup =>
      criterionGroup.criterions.flatMap(criterion =>
        criterion.giveaways.map(giveaway =>
          String(giveaway.product_id),
        )))) || []
